// extracted by mini-css-extract-plugin
module.exports = {"container":"ChannelDetails_container__18qPp","title":"ChannelDetails_title__3BLN9","header":"ChannelDetails_header__1IpYC","row":"ChannelDetails_row__2BBph"};